import React from "react";
import { TextField, MenuItem } from "@material-ui/core";

/**
 * SingleSelectFilter - Componente reutilizable para filtros de selección única.
 * Se usa para Género y Sentimiento (catálogos MongoDB).
 *
 * Props:
 * - value: string (valor seleccionado - el campo "value" del catálogo)
 * - onChange: function (callback al cambiar, recibe el value)
 * - options: array de { value: string, label: string } (opciones disponibles)
 *            También acepta array de strings para compatibilidad
 * - placeholder: string (texto por defecto)
 * - loading: boolean (si está cargando las opciones)
 */
const SingleSelectFilter = ({ value, onChange, options, placeholder, loading }) => {
    return (
        <TextField
            select
            value={value}
            variant="outlined"
            size="small"
            fullWidth
            disabled={loading}
            onChange={(e) => onChange(e.target.value)}
        >
            <MenuItem value="">
                {loading ? "Cargando..." : placeholder || "Seleccionar..."}
            </MenuItem>
            {options.map((opt, i) => {
                // Soportar tanto { value, label } como strings simples
                const optValue = typeof opt === "object" ? opt.value : opt;
                const optLabel = typeof opt === "object" ? opt.label : opt;
                return (
                    <MenuItem key={i} value={optValue}>
                        {optLabel}
                    </MenuItem>
                );
            })}
        </TextField>
    );
};

export default SingleSelectFilter;
